import script from "./fixedMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./fixedMenu.vue?vue&type=script&lang=ts&setup=true"

import "./fixedMenu.vue?vue&type=style&index=0&id=1ed94c33&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ed94c33"]])

export default __exports__